import { IAppState } from '../../common/state';
import { DISPLAY_CAROUSEL_MAX_PAGE } from 'shared/constants/newbuildingCarouselOffers';
import { selectCurrentPageNumber } from 'shared/selectors/results';
import { getNewbuildingCallPriceCarouselExperimentGroup } from 'shared/utils/experiments/getNewbuildingCallPriceCarouselExperimentGroup';

export function selectIsNewbuildingOffersCarouselVisible(state: IAppState) {
  const groupName = getNewbuildingCallPriceCarouselExperimentGroup(state.abUseExperiments);
  const pageNumber = selectCurrentPageNumber(state);

  if (pageNumber > DISPLAY_CAROUSEL_MAX_PAGE) {
    return false;
  }

  if (!state.newbuildingInformation) {
    return false;
  }

  if (!state.featureToggle.isNewbuildingOffersCarouselEnabled) {
    return false;
  }

  return groupName === 'B';
}
